// ============================================================
//  REPOSITORIO DE MEDIOS DE BEVELA  ·  Página de inicio
// ------------------------------------------------------------
//  Cambia aquí cualquier imagen o vídeo de la portada.
//  Solo tienes que sustituir la URL entre comillas por la tuya.
//
//  · IMÁGENES  → enlaces .jpg / .png / .webp (o una imagen que
//                hayas subido a Bevela).
//  · VÍDEO     → enlace .mp4 (recomendado: H.264, horizontal 16:9,
//                sin audio, de pocos segundos en bucle).
//
//  CÓMO CAMBIAR EL VÍDEO DE LA CABECERA (yate en Es Vedrà, Ibiza):
//   1. Sube tu vídeo a un enlace público .mp4, o pásamelo y lo
//      alojo en el almacenamiento de Bevela.
//   2. Pega esa URL en "heroVideo" (abajo).
//   3. En "heroPoster" pon una imagen (primer fotograma) que se
//      muestra mientras el vídeo carga y en móviles antiguos.
//   Guarda el archivo: la web se actualiza sola.
// ============================================================

export const MEDIA = {
  // ——— VÍDEO DE CABECERA ———
  // (marcador temporal: yate navegando. Sustitúyelo por tu clip de Es Vedrà)
  heroVideo: "https://videos.pexels.com/video-files/33184970/14142163_640_360_60fps.mp4",
  // Imagen de respaldo del vídeo (primer fotograma / cartel)
  heroPoster: "https://static.prod-images.emergentagent.com/jobs/6725bdb3-5390-41ce-b709-55530376423a/images/99ac7553aa405b04d5e8cc2cf6c180737ba54b1acef63d017f87c12991c2ee88.jpeg",

  // ——— IMÁGENES DE LAS SECCIONES ———
  hero: "https://static.prod-images.emergentagent.com/jobs/6725bdb3-5390-41ce-b709-55530376423a/images/99ac7553aa405b04d5e8cc2cf6c180737ba54b1acef63d017f87c12991c2ee88.jpeg",
  concept: "https://static.prod-images.emergentagent.com/jobs/6725bdb3-5390-41ce-b709-55530376423a/images/39489428f997c40f8211ed28fde29feed4e499d519da7d859179d9df84892472.jpeg",
  family: "https://static.prod-images.emergentagent.com/jobs/6725bdb3-5390-41ce-b709-55530376423a/images/dc1fe9928089053dd4abd09f286e29b326d7f518ede5ab7f8b40158ae16c4e73.jpeg",
  detail: "https://static.prod-images.emergentagent.com/jobs/6725bdb3-5390-41ce-b709-55530376423a/images/b81dcddab7e84377f501f17eacc1c98c1bb9dedbf0fca2f96fb3499305520982.jpeg",
  mediterranean: "https://images.pexels.com/photos/32762717/pexels-photo-32762717.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1600&w=2400",
};
